import { NOT_FOUND } from 'redux-first-router';

import HomeView from '../views/HomeView';
import DemoView from '../views/DemoView';
import EventsView from '../views/EventsView';
import EventsShowView from '../views/EventsShowView';
import NotFoundView from '../views/NotFoundView';
import PoliciesView from '../views/PoliciesView';
import SearchView from '../views/SearchView';
import StaticPlaceholderView from '../views/StaticPlaceholderView';

import * as types from './types';

const views = {
  [types.ROUTE_HOME]: HomeView,

  [types.ROUTE_EVENTS]: EventsView,
  [types.ROUTE_EVENTS_SHOW]: EventsShowView,

  [types.ROUTE_SEARCH]: HomeView,
  [types.ROUTE_SEARCH_QUERY_TEXT]: SearchView,

  [types.ROUTE_POLICIES]: PoliciesView,
  [types.ROUTE_STATIC_PLACEHOLDER]: StaticPlaceholderView,

  [types.ROUTE_DEMO]: DemoView,

  [NOT_FOUND]: NotFoundView,
};

export default views;



// WEBPACK FOOTER //
// ./src/routes/views.js